<template>
  <div class="content-wrapper">
    <Administrator v-if="isAdmin" />
    <Client v-else />
  </div>
</template>

<script>
import Administrator from '@/views/Dashboard/transactions/Administrator.vue';
import Client from '@/views/Dashboard/transactions/Client.vue';
export default {
  data() {
    return {
      isAdmin: false,
    };
  },
  components: {
    Administrator,
    Client,
  },
  mounted() {
    this.$forceUpdate();
  },
  beforeMount() {
    if (this.user.roles != undefined) {
      var roles = this.user.roles;
      for (var key in roles) {
        if (roles[key] == "ROLE_ADMIN") {
          this.isAdmin = true;
        }
      }
    }
  },
  computed: {
    user: {
      get() {
        return this.$store.state.user;
      },
      set(user) {
        this.$store.commit("setUser", { user: user });
      },
    },
  },
};
</script>
